import {chain} from 'lodash';

import {EmojiCategoriesEnum} from '../../../src/services/emojis/emojiList';

export function getCustomEmojiUrl(emojiRoute: string, shortcode: string) {
  return `${emojiRoute}/${shortcode}`;
}

function shortcodeToCustomDefinition(shortcode: string, toUrl: (shortcode: string) => string) {
  return {
    id: shortcode,
    shortcode,
    shortcodes: [shortcode],
    category: EmojiCategoriesEnum.CUSTOM as const,
    order: 0,
    sheetX: 0,
    sheetY: 0,
    customUrl: toUrl(shortcode),
  };
}

export function buildCustomEmojiList(shortcodes: ReadonlyArray<string>, emojiRoute: string) {
  return chain(shortcodes)
    .map((shortcode) => shortcodeToCustomDefinition(shortcode, (s) => getCustomEmojiUrl(emojiRoute, s)))
    .sortBy('shortcode')
    .value();
}
